<template>
  <div>
    <!--
        Item link fields are returned with their value as the referenced item value.
      -->
    <div>
      <!-- The referenced item's fields can be rendered and edited using normal helper components: -->
      <div v-if="memberList" class="row">
        <div v-for="member in memberList" :key="member" class="col-sm-6 col-xs-12 clients-list-div">
          <span class="clients-list">{{ member }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CIS-Members',
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  components: {},
  computed: {
    memberList() {
      return JSON.parse(this.fields?.sharedItemLink?.fields?.memberList?.value || '[""]');
    }
  }
};
</script>
